<div class="usa-accordion" >
    <h4 class="usa-accordion__heading">
        <button class="usa-accordion__button filter-category-button"
                attr.aria-expanded="{{filterCategory.isExpanded}}"
                (click)="expandClick()"
                arrr.aria-controls="filterAssetsList">
            {{title}}
        </button>
    </h4>
    <div id="filterAssetsList" *ngIf="filterCategory.isExpanded" class="usa-accordion__content usa-prose">
        <ul class="usa-list usa-list--unstyled">
            <li *ngFor="let filterValue of filterCategory.filterValues" (click)="rowClick(filterValue)" (keydown.enter)="rowClick(filterValue)" tabindex="0" class="facet-item-row">
                <a  class="usa-link">{{filterValue.displayValue}}
                    &nbsp;
                    <span *ngIf="filterValue.isIndividual" class="usa-button  usa-button--filter-count" disabled>
                        {{filterValue.count}}
                    </span>
                </a>
            </li>

            <li class="padding-left-205 margin-top-neg-2">
             <!--  value1 {{errorFound1}}
                value1 {{errorFound2}}-->

                <h4  id="{{rangeTitleId}}" class="margin-bottom-0">
                    {{rangeTitle}}
                </h4>
                <efast-errormessage [efastErrorMsg]="errorMsg"

                                    [efastErrorState]="errorFound1 || errorFound2">
                </efast-errormessage>
                <div class="filter-input-box  margin-bottom-1">
                    <efast-field-inputtext [efastErrorState]="errorFound1"
                                        [efastMaxLength]="17"
                                        [efastErrorMsg]="errorMsg"
                                        [efastLabel]=""
                                        [efastFieldId]="fieldFromId"
                                        [(efastModel)] ="applyFromValue"
                                        efastAriaLabelledBy={{rangeTitleId}}
                                        class="filter-input">
                    </efast-field-inputtext>

                    <p class="margin-x-105">
                        {{rangeToLbl}}
                    </p>
                    <efast-field-inputtext [efastErrorState]="errorFound2"
                                        [efastMaxLength]="17"
                                        [efastErrorMsg]="errorMsg"
                                        [efastLabel]=""
                                        [efastFieldId]="fieldToId"
                                        [(efastModel)] ="applyToValue"
                                        efastAriaLabelledBy={{rangeTitleId}}
                                        class="filter-input">
                    </efast-field-inputtext>
                </div>
                <br>
                <button class="usa-button  usa-button--active" type="submit" (click)='apply()' >
                    <div>
                        <span [innerHTML]="applyBtn"></span>
                    </div>
                </button>
            </li>
        </ul>
    </div>
</div>
